import { Button } from '../Button';

import './Modal.scss';

const Modal = ({ deleteUser, closeModal }) => (
  <div className="modal-box">
    <div className="modal confirmDelete">
      <h2>Do you really want to delete this person?</h2>
      <Button theme="red" onClick={closeModal}>
        Cancel
      </Button>
      <Button theme="normal" onClick={deleteUser}>
        Confirm
      </Button>
    </div>
    <div className="modal-overlay" />
  </div>
);
export default Modal;
